/**
 * Atlas Alert — Cart Sync + Home Rescue
 * v15 (2026-07-02):
 *  - Rescue overlays post-checkout (cart drawer, aph_pop, etc.)
 *  - Camera qty master → Membership qty siempre matcha
 *  - Hide Membership +/- controls con CSS + JS (NO tocar Liquid del theme)
 *  - Redirect Continue Shopping a home
 *
 * KEY LESSON: al modificar cart-drawer.liquid con {%- if -%} para omitir
 * el <quantity-input> rompe el theme JS que espera encontrarlo en TODOS
 * los line items. Solución: no tocar Liquid, solo CSS + JS.
 */
(function() {
  'use strict';

  console.log('[atlas] v34 loaded');

  const CAMERA_VARIANT_ID = 47058190991581;
  const MEMBERSHIP_VARIANT_ID = 47278461092061;
  /*
    2026-08-10: los planes de 6 y 12 meses TAMBIEN son membresia. Antes este
    script solo reconocia el variant mensual, asi que con un carrito de 3
    camaras + 3 suscripciones de 12 meses contaba mem=0, creia que faltaban y
    salia a agregar 3 mensuales — el carrito quedaba inservible a los ~1s de
    agregarlo. Si aparece otro plazo, sumar su variant aca.
  */
  const MEMBERSHIP_VARIANT_IDS = [47278461092061, 48354148909277, 48354149269725];
  function isMembershipVariant(id) { return MEMBERSHIP_VARIANT_IDS.indexOf(Number(id)) !== -1; }
  const MEMBERSHIP_SELLING_PLAN_ID = 6615138525;
  const MEMBERSHIP_HANDLE = 'atlas-alert-ai-features-membership';
  const CAMERA_HANDLE = 'atlas-alert-camera';

  let _syncing = false;
  let _lastSyncAt = 0;
  const MIN_SYNC_INTERVAL_MS = 150; // lowered from 500 — allow rapid re-syncs

  // ── PART 1: Inject CSS ──
  (function injectCss() {
    if (document.getElementById('atlas-css')) return;
    const style = document.createElement('style');
    style.id = 'atlas-css';
    style.textContent =
      /* Membership line: +/- and trash visible but disabled (greyed out).
         FIX 2026-07-03 (Ronald caso split): usar attribute selector DIRECTO
         al data-key con variant_id del Membership. Antes se dependía de la
         class .atlas-membership-line que se agrega via JS — race condition
         en /cart page (theme click handler dispara antes del mark). */
      '[data-key^="47278461092061:"] .quantity__button,' +
      '[data-key^="47278461092061:"] .qtyminus,' +
      '[data-key^="47278461092061:"] .qtyplus,' +
      '[data-key^="47278461092061:"] .qtyremove,' +
      '[data-key^="47278461092061:"] cart-remove-button,' +
      '[data-key^="47278461092061:"] .cart-remove-button,' +
      '.atlas-membership-line .quantity__button,' +
      '.atlas-membership-line .qtyminus,' +
      '.atlas-membership-line .qtyplus,' +
      '.atlas-membership-line .qtyremove,' +
      '.atlas-membership-line cart-remove-button,' +
      '.atlas-membership-line .cart-remove-button {' +
      '  pointer-events: none !important;' +
      '  opacity: 0.35 !important;' +
      '  cursor: not-allowed !important;' +
      '}' +
      '[data-key^="47278461092061:"] .quantity__input,' +
      '.atlas-membership-line .quantity__input {' +
      '  pointer-events: none !important;' +
      '  opacity: 0.55 !important;' +
      '  background: #f7f7f7 !important;' +
      '  cursor: not-allowed !important;' +
      '  read-only: true;' +
      '}' +
      /* Force icon colors dark on ALL cart drawer buttons */
      /* Also override Font Awesome duotone opacity variables */
      'cart-drawer button svg,' +
      'cart-drawer button svg *,' +
      'cart-drawer cart-remove-button svg,' +
      'cart-drawer cart-remove-button svg *,' +
      'cart-drawer button i,' +
      'cart-drawer button i::before,' +
      'cart-drawer .svg-inline--fa,' +
      'cart-drawer .svg-inline--fa *,' +
      'cart-drawer .fa-minus,' +
      'cart-drawer .fa-plus,' +
      'cart-drawer .fa-trash-can,' +
      'cart-drawer .fa-primary,' +
      'cart-drawer .fa-secondary {' +
      '  color: #000 !important;' +
      '  fill: #000 !important;' +
      '  stroke: #000 !important;' +
      '  opacity: 1 !important;' +
      '  filter: none !important;' +
      '  mix-blend-mode: normal !important;' +
      '  --fa-primary-color: #000 !important;' +
      '  --fa-secondary-color: #000 !important;' +
      '  --fa-primary-opacity: 1 !important;' +
      '  --fa-secondary-opacity: 1 !important;' +
      '}' +
      /* Hide our internal badge — we're showing native controls now */
      '.atlas-qty-badge { display: none !important; }' +
      /* Icon ↻ next to "MONTHLY MEMBERSHIP" — force dark (was inheriting white in drawer) */
      'body cart-drawer .atlas-membership-line svg.svg-inline--fa,' +
      'body cart-drawer .atlas-membership-line svg.svg-inline--fa path,' +
      'body cart-drawer .atlas-membership-line svg.fa-arrows-rotate,' +
      'body cart-drawer .atlas-membership-line svg.fa-arrows-rotate path,' +
      'body cart-drawer .atlas-membership-line .product-option--plan svg,' +
      'body cart-drawer .atlas-membership-line .product-option--plan svg path,' +
      'body cart-drawer .atlas-membership-line .icon,' +
      '.atlas-membership-line svg.svg-inline--fa,' +
      '.atlas-membership-line svg.svg-inline--fa path,' +
      '.atlas-membership-line .product-option--plan svg,' +
      '.atlas-membership-line .product-option--plan svg path {' +
      '  color: #333 !important;' +
      '  fill: #333 !important;' +
      '  opacity: 1 !important;' +
      '}' +
      '.atlas-membership-line .product-option--plan {' +
      '  margin-bottom: 0 !important;' +
      '  padding-bottom: 0 !important;' +
      '}' +
      '.atlas-mem-note {' +
      '  margin: 2px 0 0 0 !important;' +
      '  padding: 0 !important;' +
      '  font-size: 12px !important;' +
      '  color: #666 !important;' +
      '  line-height: 1.35 !important;' +
      '  font-style: normal !important;' +
      '  text-transform: none !important;' +
      '  letter-spacing: 0 !important;' +
      '}' +
      /* Margin between CHECKOUT and Shop Pay / GPay */
      '.cart__dynamic-checkout-buttons,' +
      '.additional-checkout-buttons,' +
      '[data-shopify="dynamic-checkout-cart"],' +
      '.shopify-payment-button {' +
      '  margin-top: 14px !important;' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  })();

  // ── PART 2: Mark Membership line items + update qty inputs ──
  // Detection: use data-key attribute which contains the variant_id.
  // Format: data-key="47278461092061:HASH"
  function markMembershipLineItems(overrideQty) {
    // 2026-08-10: marcar las tres variantes, no sólo la mensual. Si no, las
    // líneas de 6/12 meses quedan con los controles de cantidad habilitados y
    // el cliente puede desincronizarlas a mano.
    const memLines = document.querySelectorAll(
      MEMBERSHIP_VARIANT_IDS.map(function(v) { return '[data-key^="' + v + ':"]'; }).join(',')
    );
    memLines.forEach(function(el) {
      {
        {
          el.classList.add('atlas-membership-line');
          // Update ALL qty inputs in this line item (including hidden updates[] inputs)
          // This prevents the theme's form submit from overwriting our synced qty.
          const allQtyInputs = el.querySelectorAll(
            '.quantity__input, input[name="updates[]"], input[name*="quantity"]'
          );
          const qtyInput = el.querySelector('.quantity__input') || allQtyInputs[0];
          // 2026-07-03 (Ronald split flow): cada line item tiene su propio qty
          // (siempre 1 en el nuevo flow). NO override con overrideQty — cada
          // line item mantiene su qty individual. overrideQty se ignora aunque
          // se pase (backward compat con calls antiguos que pasaban cameraQty).
          const targetQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          // Sync all inputs
          allQtyInputs.forEach(function(inp) {
            if (parseInt(inp.value, 10) !== targetQty) {
              inp.value = String(targetQty);
            }
          });
          // Sync select (some themes use select instead of input)
          el.querySelectorAll('select[name="updates[]"], select[name*="quantity"]').forEach(function(sel) {
            if (parseInt(sel.value, 10) !== targetQty) {
              // Add option if not present
              if (!sel.querySelector('option[value="' + targetQty + '"]')) {
                const opt = document.createElement('option');
                opt.value = String(targetQty);
                opt.textContent = String(targetQty);
                sel.appendChild(opt);
              }
              sel.value = String(targetQty);
            }
          });
          // Badge (visual replacement)
          if (qtyInput && !el.querySelector('.atlas-qty-badge')) {
            const badge = document.createElement('span');
            badge.className = 'atlas-qty-badge';
            badge.textContent = 'Qty ' + targetQty;
            qtyInput.parentNode.insertBefore(badge, qtyInput);
          } else if (qtyInput) {
            const existing = el.querySelector('.atlas-qty-badge');
            if (existing) existing.textContent = 'Qty ' + targetQty;
          }
          // Fix typo: "Memebership" → "Membership" in the plan title
          const planLine = el.querySelector('.product-option--plan');
          if (planLine) {
            // Iterate text nodes and fix
            const walker = document.createTreeWalker(planLine, NodeFilter.SHOW_TEXT);
            let n;
            while ((n = walker.nextNode())) {
              if (n.nodeValue && /memebership/i.test(n.nodeValue)) {
                n.nodeValue = n.nodeValue.replace(/memebership/gi, function(m) {
                  // Preserve case: MEMEBERSHIP → MEMBERSHIP, Memebership → Membership
                  if (m === m.toUpperCase()) return 'MEMBERSHIP';
                  if (m[0] === m[0].toUpperCase()) return 'Membership';
                  return 'membership';
                });
              }
            }
          }
          // 2026-07-11 (Ronald): billing note removido — precio varía por tier
          // y no se puede calcular en tiempo real desde el cart.
          // Limpiar cualquier nota residual del DOM.
          const existingNote = el.querySelector('.atlas-mem-note');
          if (existingNote) existingNote.remove();
        }
      }
    });
  }

  function findLineItemByVariant(variantId) {
    // Uses data-key attribute which contains the variant_id
    return document.querySelector('[data-key^="' + variantId + ':"]');
  }

  // Force all cart drawer icons dark — inline !important defeats theme mobile CSS
  function forceDrawerIconsDark() {
    const iconEls = document.querySelectorAll(
      'cart-drawer button svg, cart-drawer button svg *, ' +
      'cart-drawer cart-remove-button svg, cart-drawer cart-remove-button svg *, ' +
      'cart-drawer .svg-inline--fa, cart-drawer .svg-inline--fa *, ' +
      'cart-drawer .icon, cart-drawer .icon *'
    );
    iconEls.forEach(function(el) {
      // Skip if inside atlas-membership-line (we want those disabled/tenue)
      if (el.closest && el.closest('.atlas-membership-line')) return;
      el.style.setProperty('fill', '#000', 'important');
      el.style.setProperty('stroke', 'none', 'important');
      el.style.setProperty('color', '#000', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('filter', 'none', 'important');
    });
  }

  function reorderCameraFirst() {
    // FIX 2026-07-03 (Ronald split flow): NO reorder en /cart page. El theme
    // MARA hace form-submit con updates[] EN ORDEN DEL DOM. Si reordeamos,
    // los updates[] se aplican a las backend lines equivocadas — Camera qty
    // termina en Mem line, etc. → checkout con qty mal.
    // Reorder solo en cart drawer (donde el checkout button no submit form).
    if (window.location.pathname === '/cart') return;
    const memItem = findLineItemByVariant(MEMBERSHIP_VARIANT_ID);
    const camItem = findLineItemByVariant(CAMERA_VARIANT_ID);
    if (!memItem || !camItem) return;
    if (memItem.parentElement === camItem.parentElement) {
      if (camItem.nextElementSibling === memItem) return;
      camItem.parentElement.insertBefore(memItem, camItem.nextSibling);
    }
  }

  // ── PART 3: Sync qty (Camera master) ──
  function countIn(cart, variantId) {
    return (cart.items || [])
      .filter(function(i) { return i.variant_id === variantId; })
      .reduce(function(sum, i) { return sum + i.quantity; }, 0);
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function changeQtyByKey(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  // 2026-07-03 (Ronald): SPLIT membership en N line items separados.
  // Cada line item con _slot property único → SEAL crea N subs independientes.
  // startSlot = slot number del PRIMER item a agregar (para no colisionar
  // con Memberships ya en cart).
  async function addMembershipWithPlan(quantity, startSlot, refItems) {
    const items = [];
    const s = startSlot || 1;
    /*
      2026-08-10: clonar el plazo que el cliente YA eligió. Si en el carrito
      hay suscripciones de 6 o 12 meses, las nuevas líneas tienen que ser del
      mismo producto y el mismo selling plan — antes se agregaba siempre la
      mensual y quedaba un carrito mezclado (2 cams + 1 sub de 6 meses + 1
      mensual de $0). Sin referencia, mensual como siempre.
    */
    const ref = (refItems || [])[0];
    const vid = ref ? ref.variant_id : MEMBERSHIP_VARIANT_ID;
    const pid = (ref && ref.selling_plan_allocation && ref.selling_plan_allocation.selling_plan)
      ? ref.selling_plan_allocation.selling_plan.id
      : MEMBERSHIP_SELLING_PLAN_ID;
    for (let i = 0; i < quantity; i++) {
      items.push({
        id: vid,
        quantity: 1,
        selling_plan: pid,
        properties: { Unit: String(s + i) }
      });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    });
  }

  async function syncMembership() {
    if (_syncing) return;
    const now = Date.now();
    if (now - _lastSyncAt < MIN_SYNC_INTERVAL_MS) return;
    _lastSyncAt = now;
    _syncing = true;
    try {
      const cart = await getCart();
      const cameraQty = countIn(cart, CAMERA_VARIANT_ID);
      const memItems = (cart.items || []).filter(function(i) { return isMembershipVariant(i.variant_id); });
      // 2026-07-03 (Ronald split membership): SUM de qty en todos los line
      // items de Membership. Con nuevo flow N line items qty=1, memTotalQty
      // === memItems.length. Fallback para carts legacy con 1 line item qty>1.
      const memTotalQty = memItems.reduce(function(s, i) { return s + i.quantity; }, 0);
      if (cameraQty === memTotalQty) {
        console.log('[atlas] in sync — cam:' + cameraQty + ' mem_total:' + memTotalQty + ' mem_lines:' + memItems.length);
      } else {
        console.log('[atlas] DESYNC — cam:' + cameraQty + ' mem_total:' + memTotalQty + ' target=' + cameraQty);
        if (cameraQty === 0) {
          for (const mi of memItems) {
            await changeQtyByKey(mi.key, 0);
          }
        } else if (memItems.length === 0) {
          await addMembershipWithPlan(cameraQty, 1);
        } else if (cameraQty > memTotalQty) {
          // Add more line items starting from max_slot+1
          let maxSlot = 0;
          for (const mi of memItems) {
            const p = (mi.properties || {}).Unit;
            const n = p ? parseInt(p, 10) : 0;
            if (n > maxSlot) maxSlot = n;
          }
          await addMembershipWithPlan(cameraQty - memTotalQty, maxSlot + 1, memItems);
        } else if (cameraQty < memTotalQty) {
          // Remove excess — higher slot first (most recent)
          const needRemove = memTotalQty - cameraQty;
          let removed = 0;
          const sortedMem = memItems.slice().sort(function(a, b) {
            const aSlot = parseInt((a.properties || {})._slot || '0', 10);
            const bSlot = parseInt((b.properties || {})._slot || '0', 10);
            return bSlot - aSlot;
          });
          for (const mi of sortedMem) {
            if (removed >= needRemove) break;
            const canRemove = Math.min(mi.quantity, needRemove - removed);
            await changeQtyByKey(mi.key, mi.quantity - canRemove);
            removed += canRemove;
          }
        }
      }
      // Update all inputs so form-submit at checkout uses correct qty
      markMembershipLineItems(cameraQty); forceDrawerIconsDark();
      reorderCameraFirst();
    } catch (e) {
      console.warn('[atlas] sync error:', e);
    } finally {
      _syncing = false;
    }
  }

  // Hook fetch — parse the RESPONSE body (which is the fresh cart) instead of
  // re-fetching /cart.js later. This eliminates timing race between theme
  // fetch and our sync.
  const originalFetch = window.fetch;
  window.fetch = function(input, init) {
    const url = (typeof input === 'string') ? input : (input && input.url) || '';
    const isCartMutation =
      /\/cart\/(change|update|add|clear)(\.js|\?)/.test(url) ||
      /\/cart\/(change|update|add|clear)$/.test(url) ||
      /\/cart\/change_line/.test(url);
    const promise = originalFetch.apply(this, arguments);
    if (isCartMutation && !_syncing) {
      promise.then(async function(r) {
        try {
          const clone = r.clone();
          const cart = await clone.json();
          if (cart && cart.items) {
            const cam = countIn(cart, CAMERA_VARIANT_ID);
            const memItems = (cart.items || []).filter(function(i) { return isMembershipVariant(i.variant_id); });
            const mem = memItems.reduce(function(s, i) { return s + i.quantity; }, 0);
            console.log('[atlas] mutation response — cam:' + cam + ' mem:' + mem + ' url:' + url);
            if (cam !== mem) {
              // Sync immediately using this fresh cart data
              setTimeout(function() { syncFromKnownCart(cart, cam, mem, memItems); }, 30);
            } else {
              // Even if in sync, refresh UI
              setTimeout(function() { markMembershipLineItems(); forceDrawerIconsDark(); reorderCameraFirst(); }, 30);
            }
          }
        } catch (e) {
          // Response body not cart JSON (e.g. /cart/clear returns empty) — fall back to getCart
          setTimeout(syncMembership, 200);
        }
        return r;
      }).catch(function() {});
    }
    return promise;
  };

  // Sync using a known-fresh cart (skip getCart round-trip)
  /*
    2026-08-11: los 3 plazos con sus 4 tiers. Mismos IDs que usan el checkout y
    cart-template — si se recrean las reglas en SEAL hay que actualizar los tres
    lugares.
  */
  /*
    2026-08-11: indicador de "actualizando". El re-tier hace varias llamadas y
    el drawer se queda mostrando lo viejo mientras tanto — parecia colgado.
    Ademas bloquea los clics: sin esto el visitante puede apretar "+" otra vez
    en el medio y dispara un segundo sync sobre un carrito a medio rehacer.
  */
  var _busyStyleAdded = false;
  function setBusy(on) {
    try {
      if (!_busyStyleAdded) {
        var st = document.createElement('style');
        st.textContent =
          '.atlas-busy{position:relative;pointer-events:none}' +
          '.atlas-busy::after{content:"";position:absolute;inset:0;background:rgba(255,255,255,.55);z-index:998}' +
          '.atlas-busy::before{content:"";position:absolute;top:50%;left:50%;width:26px;height:26px;' +
          'margin:-13px 0 0 -13px;border:3px solid rgba(0,0,0,.15);border-top-color:rgba(0,0,0,.55);' +
          'border-radius:50%;animation:atlasSpin .7s linear infinite;z-index:999}' +
          '@keyframes atlasSpin{to{transform:rotate(360deg)}}';
        document.head.appendChild(st);
        _busyStyleAdded = true;
      }
      var nodes = document.querySelectorAll('cart-drawer .drawer__inner, #main-cart-items, .cart__items');
      for (var i = 0; i < nodes.length; i++) {
        if (on) nodes[i].classList.add('atlas-busy');
        else nodes[i].classList.remove('atlas-busy');
      }
    } catch (e) {}
  }
  /*
    Contador, no un booleano: el sync y el clic pueden pedir el indicador a la
    vez y el que termina primero no debe apagarselo al otro.
    El watchdog es deliberado: el overlay bloquea los clics, asi que un error
    inesperado dejaria el carrito inusable. Preferimos destaparlo tarde antes
    que dejar al cliente trabado.
  */
  var _busyCount = 0, _busyTimer = null;
  function busyStart() {
    _busyCount++;
    setBusy(true);
    if (_busyTimer) clearTimeout(_busyTimer);
    _busyTimer = setTimeout(function() { _busyCount = 0; setBusy(false); }, 8000);
  }
  function busyEnd() {
    _busyCount = Math.max(0, _busyCount - 1);
    if (_busyCount === 0) {
      if (_busyTimer) { clearTimeout(_busyTimer); _busyTimer = null; }
      setBusy(false);
    }
  }
  /*
    Los repintados van en cadena. Dos refreshCartUI en paralelo se pisan: cada
    uno escribe el innerHTML del drawer con la respuesta de SU fetch, y gana el
    que llega ultimo — que no es necesariamente el mas nuevo.
  */
  var _refreshChain = Promise.resolve();
  function queueRefresh() {
    _refreshChain = _refreshChain.then(function() { return refreshCartUI(); })
                                 .catch(function() {});
    return _refreshChain;
  }
  /*
    Repinta cuando el sync se asienta. El clic llega ANTES de que el sync
    arranque (el interceptor necesita la respuesta del theme), asi que primero
    esperamos a que arranque — con techo, por si ese clic no genera desync y no
    hay sync ninguno que esperar.
  */
  function refreshWhenSettled() {
    var t0 = Date.now();
    busyStart();
    (function wait() {
      var arranco = _lastSyncAt >= t0;
      if (_syncing || (!arranco && Date.now() - t0 < 1500)) {
        setTimeout(wait, 50);
        return;
      }
      queueRefresh().then(busyEnd);
    })();
  }
  const TIER_PLANS_BY_VARIANT = {
    47278461092061: { 1: 6615138525, 2: 6628737245, 3: 6628770013, 4: 6628802781 },
    48354148909277: { 1: 6688276701, 2: 6688309469, 3: 6688342237, 4: 6688375005 },
    48354149269725: { 1: 6688407773, 2: 6688440541, 3: 6688473309, 4: 6688506077 }
  };
  async function reTierIfNeeded(cameraQty) {
    if (!cameraQty || cameraQty < 1) return;
    const cart = await getCart();
    const mem = (cart.items || []).filter(function(i) { return isMembershipVariant(i.variant_id); });
    if (!mem.length) return;
    const vid = Number(mem[0].variant_id);
    const tiers = TIER_PLANS_BY_VARIANT[vid];
    if (!tiers) return;
    const wanted = tiers[Math.min(Math.max(cameraQty, 1), 4)];
    const wrong = mem.some(function(i) {
      return i.selling_plan_allocation
        && i.selling_plan_allocation.selling_plan
        && i.selling_plan_allocation.selling_plan.id !== wanted;
    });
    if (!wrong) return;
    console.log('[atlas] re-tier -> plan ' + wanted + ' para ' + cameraQty + ' cams');
    // Una sola llamada en vez de una por linea: /cart/update.js acepta todas
    // las claves juntas. Con 4 suscripciones son 3 viajes menos al servidor.
    const updates = {};
    for (const mi of mem) { updates[mi.key] = 0; }
    const doFetch2 = (typeof originalFetch === 'function') ? originalFetch : window.fetch;
    await doFetch2('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });
    // refItem sintetico: fuerza variante y plan del tier correcto
    await addMembershipWithPlan(cameraQty, 1, [{
      variant_id: vid,
      selling_plan_allocation: { selling_plan: { id: wanted } }
    }]);
  }
  async function syncFromKnownCart(cart, cameraQty, memQty, memItems) {
    if (_syncing) return;
    _syncing = true;
    _lastSyncAt = Date.now();
    // El indicador cubre todo el sync, no solo el re-tier: ajustar cantidades
    // tambien hace llamadas y el carrito queda desactualizado mientras tanto.
    busyStart();
    try {
      // 2026-07-03 (Ronald split membership): use memItems array, handle N line items
      console.log('[atlas] sync from response — cam:' + cameraQty + ' mem_total:' + memQty + ' mem_lines:' + memItems.length);
      if (cameraQty === 0) {
        for (const mi of memItems) {
          await changeQtyByKey(mi.key, 0);
        }
        if (memItems.length > 0) console.log('[atlas] removed ' + memItems.length + ' membership line(s)');
      } else if (memItems.length === 0) {
        await addMembershipWithPlan(cameraQty, 1);
        console.log('[atlas] added ' + cameraQty + ' membership line(s)');
      } else if (cameraQty > memQty) {
        let maxSlot = 0;
        for (const mi of memItems) {
          const p = (mi.properties || {}).Unit;
          const n = p ? parseInt(p, 10) : 0;
          if (n > maxSlot) maxSlot = n;
        }
        await addMembershipWithPlan(cameraQty - memQty, maxSlot + 1, memItems);
      } else if (cameraQty < memQty) {
        const needRemove = memQty - cameraQty;
        let removed = 0;
        const sortedMem = memItems.slice().sort(function(a, b) {
          const aSlot = parseInt((a.properties || {})._slot || '0', 10);
          const bSlot = parseInt((b.properties || {})._slot || '0', 10);
          return bSlot - aSlot;
        });
        for (const mi of sortedMem) {
          if (removed >= needRemove) break;
          const canRemove = Math.min(mi.quantity, needRemove - removed);
          await changeQtyByKey(mi.key, mi.quantity - canRemove);
          removed += canRemove;
        }
      }
      // Cantidad ya igualada; ahora el % por cantidad.
      await reTierIfNeeded(cameraQty);
    } catch (e) {
      console.warn('[atlas] sync-from-cart error:', e);
    } finally {
      _syncing = false;
      // Update UI + all qty inputs to prevent form-submit overwrite at checkout
      setTimeout(function() { markMembershipLineItems(cameraQty); forceDrawerIconsDark(); reorderCameraFirst(); }, 100);
      // FIX 2026-07-03 (Ronald split flow): en /cart page el theme del cart no
      // re-renderiza después de nuestro add/remove — quedan Mem items faltantes
      // o extra visualmente. Backend está OK pero UI stale. Solution: reload
      // /cart page después de un sync que agrega/quita line items.
      if (window.location.pathname === '/cart') {
        setTimeout(function() { window.location.reload(); }, 400);
      } else {
        setTimeout(function() { queueRefresh().then(busyEnd); }, 120);
      }
    }
  }

  // XHR hook
  const XHR = window.XMLHttpRequest.prototype;
  const _open = XHR.open, _send = XHR.send;
  XHR.open = function(m, u) { this._atlasUrl = u; return _open.apply(this, arguments); };
  XHR.send = function() {
    const url = this._atlasUrl || '';
    const isCartMutation =
      /\/cart\/(change|update|add|clear)(\.js|\?)/.test(url) ||
      /\/cart\/(change|update|add|clear)$/.test(url);
    if (isCartMutation && !_syncing) {
      console.log('[atlas] XHR mutation:', url);
      this.addEventListener('load', function() { setTimeout(syncMembership, 250); });
    }
    return _send.apply(this, arguments);
  };

  // ── Listen to click events on qty +/- buttons in cart page as fallback ──
  // Some theme JS calls cart update through internal methods that we can't intercept easily.
  // Fallback: after ANY click on qty buttons or qty input change, trigger a sync.
  // ── After sync: refresh cart UI (backend is fine, only UI stale) ──
  async function refreshCartUI() {
    /*
      2026-08-11: fuera de /cart el sync corregia el carrito pero el DRAWER
      seguia mostrando lo viejo — con 2 camaras se veian 3 suscripciones, y con
      el tier equivocado. Aca no se puede recargar la pagina (el cliente esta
      navegando), asi que se repinta con el mecanismo del propio theme:
      pedir las secciones del drawer y pasarselas a renderContents().
    */
    if (window.location.pathname !== '/cart') {
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
        const ids = drawer.getSectionsToRender().map(function(s) { return s.id; }).join(',');
        const doFetch = (typeof originalFetch === 'function') ? originalFetch : window.fetch;
        const rd = await doFetch(window.location.pathname + '?sections=' + ids, { credentials: 'same-origin' });
        if (!rd.ok) return;
        drawer.renderContents({ sections: await rd.json() });
      } catch (e) { /* si el theme cambia, no romper el sync */ }
      return;
    }
    // On /cart page: fetch main-cart-items section and swap innerHTML
    if (window.location.pathname === '/cart') {
      try {
        const r = await fetch('/cart?sections=main-cart-items,main-cart-footer,cart-icon-bubble', {
          credentials: 'same-origin'
        });
        if (!r.ok) return;
        const data = await r.json();
        for (const sectionId of ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble']) {
          const html = data[sectionId];
          if (!html) continue;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector('#' + sectionId + ', [data-id="' + sectionId + '"], [id*="' + sectionId + '"]');
          const curSection = document.querySelector('#' + sectionId + ', [data-id="' + sectionId + '"], [id*="' + sectionId + '"]');
          if (newSection && curSection) {
            // Prefer replacing inner content of matching container
            curSection.innerHTML = newSection.innerHTML;
          }
        }
        markMembershipLineItems(); forceDrawerIconsDark();
        reorderCameraFirst();
        console.log('[atlas] cart UI refreshed');
      } catch (e) {
        console.warn('[atlas] refresh cart error:', e);
      }
    } else {
      // In drawer: fetch cart-drawer section
      try {
        const r = await fetch('/?sections=cart-drawer', { credentials: 'same-origin' });
        if (!r.ok) return;
        const data = await r.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const cur = document.querySelector('cart-drawer');
        if (newDrawer && cur) {
          cur.innerHTML = newDrawer.innerHTML;
          markMembershipLineItems(); forceDrawerIconsDark();
          reorderCameraFirst();
          console.log('[atlas] drawer UI refreshed');
        }
      } catch (e) {
        console.warn('[atlas] refresh drawer error:', e);
      }
    }
  }

  document.addEventListener('click', function(e) {
    const t = e.target;
    if (!t || !t.closest) return;
    const qtyBtn = t.closest('.quantity__button, .qtyminus, .qtyplus, cart-remove-button, .cart-remove-button');
    if (qtyBtn) {
      if (qtyBtn.closest('.atlas-membership-line')) return;
      // 2026-08-11: antes eran dos repintados a 600 y 1400 ms "por si el sync
      // es lento". Ahora se espera al sync: ni tarde ni de mas.
      refreshWhenSettled();
    }
  }, false);

  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t) return;
    if (t.matches && t.matches('.quantity__input, input[name="updates[]"]')) {
      if (t.closest('.atlas-membership-line')) return;
      refreshWhenSettled();
    }
  }, false);

  /*
    2026-08-11: el checkout de la home navega por location.href, y el guard de mas
    abajo solo intercepta clicks. Sin esto, ir directo a /checkout se saltearia el
    sync y el visitante podria pagar con lineas de una sesion anterior sin corregir.
  */
  window.atlasSyncNow = async function() {
    try {
      _lastSyncAt = 0;
      await syncMembership();
    } catch (e) {
      console.warn('[atlas] atlasSyncNow error:', e);
    }
  };

  /*
    Suspende el sync mientras el builder rehace el carrito. Un clear seguido de un
    add pasa por un estado transitorio de 0 camaras y 0 membresias; sin esto el
    interceptor puede disparar un sync justo en el medio y trabajar sobre un
    carrito que ya no existe. Se libera al terminar y el sync corre una sola vez.
  */
  window.atlasSuspendSync = function(on) {
    _syncing = !!on;
    if (!on) _lastSyncAt = 0;
  };

  // ── PART 4: CHECKOUT guard (sync before submit) ──
  let _bypassCheckout = false;
  document.addEventListener('click', async function(e) {
    if (_bypassCheckout) return;
    const t = e.target;
    if (!t || !t.closest) return;
    const btn = t.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]:not([type="button"])');
    if (!btn) return;
    if (btn.closest('[data-shopify="dynamic-checkout-cart"], .shopify-payment-button')) return;
    console.log('[atlas] checkout intercepted — sync then submit');
    e.preventDefault();
    e.stopPropagation();
    _lastSyncAt = 0;
    await syncMembership();
    await new Promise(function(r) { setTimeout(r, 200); });
    _bypassCheckout = true;
    try { btn.click(); } catch (_) {}
    setTimeout(function() { _bypassCheckout = false; }, 2000);
  }, true);

  // ── PART 5: Sync on load + observe cart changes ──
  function scopedObserve() {
    const targets = Array.from(document.querySelectorAll(
      'cart-drawer, #cart-drawer, .cart-drawer, #main-cart, cart-items'
    ));
    if (targets.length === 0) return;
    const apply = function() {
      markMembershipLineItems(); forceDrawerIconsDark();
      reorderCameraFirst();
    };
    targets.forEach(function(t) {
      const obs = new MutationObserver(function() {
        clearTimeout(window._atlasObsTimer);
        window._atlasObsTimer = setTimeout(apply, 150);
      });
      obs.observe(t, { childList: true, subtree: true });
    });
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncMembership();
      scopedObserve();
    });
  } else {
    syncMembership();
    scopedObserve();
  }
  window.addEventListener('pageshow', function() {
    setTimeout(function() { markMembershipLineItems(); forceDrawerIconsDark(); reorderCameraFirst(); }, 100);
  });

  window.atlas = { sync: syncMembership, mark: markMembershipLineItems };
})();

